import { render, staticRenderFns } from "./EventsListSimilar.vue?vue&type=template&id=590c9a9c&"
import script from "./EventsListSimilar.vue?vue&type=script&lang=js&"
export * from "./EventsListSimilar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports